export const ceoSteps = [
    {
      name: 'age_selection',
      component: 'AgeSelection',
      props: {
        options: [
          { ageRange: '18-26', iconPath: 'ceo' },
          { ageRange: '27-36', iconPath: 'ceo' },
          { ageRange: '37-45', iconPath: 'ceo' },
          { ageRange: '46+', iconPath: 'ceo' },
        ],
        title: 'Discover your CEO mindset'
      }
    },
    {
      name: 'testimonial_selection',
      component: 'TestimonialSection',
      props: {
        imgName: 'book_reading',
        title: 'Sparkle is a tool for acquiring and absorbing as much information as possible',
        text: 'We’ll help you with self-growth. First, let’s dive into your personality and tailor your personal plan.'
      }
    },
    {
      name: 'gender_selection',
      component: 'GenderSelect',
      props: {
        options:
          [
            { sendGTag: true, icon: '👨🏻', text: 'Male' },
            { sendGTag: true, icon: '👩🏻', text: ' Female' },
            { sendGTag: true, icon: '🧑🏻‍🦰', text: ' Non-Binary' },
          ],
        title: 'Select your gender identity'
      },
      dynamicResponse: false,
      responsePage: {
        component: 'InformationCard',
        props: {
          imgName: 'ceo-sitting-at-desk',
          title: "Looking forward to what's ahead!",
          text: 'Becoming a strong leader starts with self-awareness. We’ll explore your unique strengths and create a roadmap tailored to your professional growth.'
        }
      },
      section: 'Introduction'
    },
    {
      name: 'areas_selection',
      component: 'MultiSelectCard',
      props: {
        options: [
          { iconPath: 'areas/communication.png', text: 'Negotiation' },
          { iconPath: 'areas/leadership.svg', text: 'Leadership' },
          { iconPath: 'areas/crisis-management.svg', text: 'Crisis Management' },
          { iconPath: 'areas/influence.svg', text: 'Influence' },
          { iconPath: 'areas/critical-thinking.svg', text: 'Critical Thinking' },
          { iconPath: 'areas/creativity.png', text: 'Decision Making' },
          { iconPath: 'areas/resilience.svg', text: 'Resilience' },
        ],
        title: "Select the skills you'd like to enhance",
        text: ''
      },
      responsePage: {
        component: 'InformationCard',
        props: {
          imgName: 'leverage_strength',
          title: 'Leverage your strengths with insights from professionals.',
          text: "Sparkle empowers you with strategic insights and practical skills, helping you lead with confidence and drive real change from day one."
        }
      },
      section: 'Introduction'
    },
    {
      name: 'people_selection',
      component: 'MultiSelectCard',
      props: {
        options: [
          { imgPath: 'musk_black_white.png', text: 'Elon Musk' },
          { imgPath: 'oprah_black_white.png', text: 'Oprah Winfrey' },
          { imgPath: 'bezos.png', text: 'Jeff Bezos' },
          { imgPath: 'jobs.png', text: 'Steve Jobs' },
          { imgPath: 'tim_cook_black_white.png', text: 'Tim Cook' },
          { imgPath: 'branson.png', text: 'Richard Branson' },
          { imgPath: 'pichai.png', text: 'Sundar Pichai' },
          { imgPath: 'nooyi.png', text: 'Indra Nooyi' },
          { imgPath: 'sandberg.png', text: 'Sheryl Sandberg' },
        ],
        title: 'Which leader\'s values, achievements, and vision inspire you the most?',
      },
      section: 'Introduction'
    },
    {
      name: 'personal_view',
      component: 'SelectOneList',
      props: {
        options: [
          {
            icon: '🔭',
            text: 'Generalist',
            sideText: '(Broad vision, diverse skills)'
          },
          {
            icon: '🔬',
            text: 'Specialist',
            sideText: '(Detail-driven, focused expertise)'
          }
        ],
        title: 'Do you consider yourself more of a visionary or a detail-focused thinker?'
      },
      section: 'Leadership'
    },
    {
      name: 'describe_self',
      component: 'SelectOneList',
      props: {
        title: 'How do you naturally approach situations?',
        gridCols: 2,
        options: [
          {
            icon: '🏆',
            text: 'Leader',
          },
          {
            icon: '🤝',
            text: 'Team player',
          },
          {
            icon: '⚒️',
            text: 'Problem-solver',
          },
          {
            icon: '🎭',
            text: 'Flexible',
          }
        ],
      },
      section: 'Leadership'
    },
    {
      name: 'leadership_style',
      component: 'SelectOneList',
      props: {
        title: 'Which leadership approach aligns with your style?',
        options: [
          {
            icon: '🧭',
            text: 'Coach-Style Leadership',
          },
          {
            icon: '🎯',
            text: 'Visionary Leadership',
          },
          {
            icon: '🙌🏻',
            text: 'Supportive Leadership',
          },
          {
            icon: '🪄',
            text: 'Inspirational Leadership',
          }
        ],
      },
      section: 'Leadership'
    },
    {
      name: 'decision_making',
      component: 'SelectOneRow',
      props: {
        title: 'It is hard for me to decide quickly.',
        options: [
          {
            text: '❌',
            responsePage: {
              component: 'InformationCard',
              props: {
                imgName: 'ceo_can_decide',
                title: 'Taking a moment to pause before deciding shows careful thought. 🌟',
                text: "With a little practice, you can build confidence to make decisions quickly without sacrificing quality.",
              }
            }
          },
          {
            text: '🤔',
            responsePage: {
              component: 'InformationCard',
              props: {
                imgName: 'ceo_neutral_decide',
                title: 'It\'s natural to feel uncertain when making decisions, but hesitation can occasionally slow you down.',
                text: 'While it can sometimes slow things down, learning to balance speed with thoughtful consideration is key. We’ll guide you through it.'
              }
            }
          },
          {
            text: '✅',
            responsePage: {
              component: 'InformationCard',
              props: {
                imgName: 'ceo_cannot_decide',
                title: 'Overthinking can lead to missed opportunities. ',
                text: 'Hesitation may hold you back, but we’ll work on strategies to overcome this hurdle and boost your decision-making speed.'
              }
            }
          }
        ]
      },
      dynamicResponse: true,
      section: 'Leadership'
    },
    {
      name: 'extrovert_introvert',
      component: 'Slider',
      props: {
        options: [
          {
            emoji: '🧐',
            text: 'Introvert',
            value: 'Introvert',
            responsePage: {
              component: 'InformationCard',
              props: {
                imgName: 'ceo_introvert',
                title: 'Your leadership style is similar to Elon Musk and Indra Nooyi! 🌟',
                text: 'Your innovative mindset and strategic thinking are your strengths. With Sparkle, you’ll learn to channel these traits into exceptional outcomes.'
              }
            }
          },
          {
            emoji: '🙂',
            text: 'Balanced',
            value: 'Balanced',
            responsePage: {
              component: 'InformationCard',
              props: {
                imgName: 'ceo_ambivert',
                title: 'Your leadership style is similar to Oprah Winfrey and Tim Cook! 🤔',
                text: 'Your potential is clear, but refining your skills could make you unstoppable. Sparkle provides the insights you need to grow at your own pace.'
              }
            }
          },
          {
            emoji: '😁',
            text: 'Extrovert',
            value: 'Extrovert',
            responsePage: {
              component: 'InformationCard',
              props: {
                imgName: 'ceo_extrovert',
                title: 'Your leadership style is similar to Jeff Bezos and Satya Nadella!',
                text: 'Resilience and adaptability are critical, and Sparkle can help you uncover the tools to thrive under pressure.'
              }
            }
          },
        ],
        title: 'How would you describe yourself?'
      },
      dynamicResponse: true,
      section: 'Leadership'
    },
    {
      name: 'healthy_habits',
      component: 'SelectOneRow',
      props: {
        title: 'Do you believe that healthy living habits affect your work performance?',
        options: [
          {
            text: '❌',
            responsePage: {
              component: 'FeedbackPage',
              props: {
                title: "A balanced lifestyle that includes exercise and rest can support your well-being.",
                text: "While it’s not the only factor, it plays an important role in maintaining peak performance."
              }
            }
          },
          {
            text: '🤔',
            responsePage: {
              component: 'FeedbackPage',
              props: {
                title: "Skipping on workouts and proper sleep can drain your energy. ⚠️",
                text: "It’s hard to stay productive without prioritizing your physical and mental health."
              }
            }
          },
          {
            text: '✅',
            responsePage: {
              component: 'FeedbackPage',
              props: {
                title: "You're absolutely right! 🌟",
                text: "Incorporating regular exercise and proper rest is key to maintaining energy, focus, and productivity."
              }
            }
          }
        ],
      },
      dynamicResponse: true,
      section: 'Leadership'
    },
    {
      name: 'friendly_push',
      component: 'SelectOneRow',
      props: {
        title: 'Do you need extra motivation from time to time?',
        options: [
          {
            text: '❌',
            responsePage: {
              component: 'InformationCard',
              props: {
                imgName: 'ceo_no_extra_motivation',
                title: "Different approaches work for different people, and that’s perfectly natural.",
                text: "While creating your growth plan, we will keep this in mind."
              }
            }
          },
          {
            text: '🤔',
            responsePage: {
              component: 'InformationCard',
              props: {
                imgName: 'ceo_extra_motivation',
                title: 'Sometimes a little encouragement can make wonders.',
                text: 'While creating your growth plan, we will keep this in mind.'
              }
            }
          },
          {
            text: '✅',
            responsePage: {
              component: 'InformationCard',
              props: {
                imgName: 'ceo_extra_motivation',
                title: 'Sometimes a little encouragement can make wonders.',
                text: 'While creating your growth plan, we will keep this in mind.'
              }
            }
          }
        ]
      },
      dynamicResponse: true,
      section: 'Leadership'
    },
    {
      name: 'time_management',
      component: 'SelectOneRow',
      props: {
        title: "Could better time management help you be more productive?",
        options: [
          {
            text: '❌',
            responsePage: {
              component: 'FeedbackPage',
              props: {
                title: "Struggling with time management can slow down your progress. ⚠️",
                text: "It’s a challenge, but with the right tools, you can overcome it. Let’s help you get back on track."
              }
            }
          },
          {
            text: '🤔',
            responsePage: {
              component: 'FeedbackPage',
              props: {
                title: "Time management is an important step toward achieving your goals. 🤔",
                text: "You’re not alone—many find it challenging, but we’re here to guide you through it."
              }
            }
          },
          {
            text: '✅',
            responsePage: {
              component: 'FeedbackPage',
              props: {
                title: "Your drive to improve is inspiring! 💪",
                text: "Most of our users agree that mastering time management is key to achieving their dreams. Let’s work on it together."
              }
            }
          }
        ],
      },
      dynamicResponse: true,
      section: 'Leadership'
    },
    {
      name: 'disconnect_after_work',
      component: 'SelectOneRow',
      props: {
        title: "Do you find it hard to disconnect from work after hours?",
        options: [
          {
            text: '❌',
            responsePage: {
              component: 'InformationCard',
              props: {
                imgName: 'ceo_cannot_disconnect_after_work',
                title: "Struggling to set boundaries can lead to burnout. ⚠️",
                text: "While they might make you question your abilities, they also offer a chance to reflect and improve. Your personalized plan will guide you in managing both setbacks and growth moments."
              }
            }
          },
          {
            text: '🤔',
            responsePage: {
              component: 'InformationCard',
              props: {
                imgName: 'ceo_neutral_disconnect_after_work',
                title: "Establishing boundaries is essential for maintaining balance. 🤔",
                text: "It’s not always easy, but it’s an important skill for long-term success and healthy communication. We’ll guide you through it."
              }
            }
          },
          {
            text: '✅',
            responsePage: {
              component: 'InformationCard',
              props: {
                imgName: 'ceo_can_disconnect_after_work',
                title: "Setting boundaries shows strength and self-respect. 💪",
                text: "It’s a key step toward achieving balance and success. We’ll help you refine the skills to communicate them effectively."
              }
            }
          }
        ],
      },
      dynamicResponse: true,
      section: 'Leadership'
    },
    {
      name: 'point_in_career',
      component: 'Slider',
      props: {
        options: [
          {
            emoji: '☹️',
            text: 'Nah!',
            value: 'Nah!',
            responsePage: {
              component: 'InformationCard',
              props: {
                imgName: 'ceo_point_in_career_nah',
                title: "Without self-reflection, leadership can lack direction.⚠️ ",
                text: "It’s crucial to examine your goals and decisions to avoid repeating mistakes. We’ll help you develop this skill."
              }
            }
          },
          {
            emoji: '🙂',
            text: 'Balanced',
            value: 'Balanced',
            responsePage: {
              component: 'InformationCard',
              props: {
                imgName: 'ceo_point_in_career_balanced',
                title: "Leadership starts with understanding yourself. 🤔",
                text: "Taking time to reflect on your choices and strategies will strengthen your ability to lead effectively. Let’s work on this together."
              }
            }
          },
          {
            emoji: '😁',
            text: 'Yeah!',
            value: 'Yeah!',
            responsePage: {
              component: 'InformationCard',
              props: {
                imgName: 'ceo_point_in_career_yeah',
                title: "Great leaders grow through self-awareness. 🌟",
                text: "By reflecting on your actions and decisions, you’ll unlock your potential to inspire and guide others effectively."
              }
            }
          },
        ],
        title: "I am at the point I want to be in my career."
      },
      dynamicResponse: true,
      section: 'Leadership'
    },
    {
      name: 'enjoy_your_job',
      component: 'SelectOneRow',
      props: {
        title: 'Do you enjoy your job?',
        options: [
          {
            text: '❌',
            responsePage: {
              component: 'FeedbackPage',
              props: {
                title: 'You’re not alone!',
                text: "Sparkle has helped millions find a fast way to improve their lives in minutes a day. Don’t worry, we got you!"
              }
            }
          },
          {
            text: '🤔',
            responsePage: {
              component: 'FeedbackPage',
              props: {
                title: 'Thinking about making a change?',
                text: "While transitions can be tough, having a plan makes them manageable. We’ll work with you to target your growth areas and achieve meaningful change."
              }
            }
          },
          {
            text: '✅',
            responsePage: {
              component: 'FeedbackPage',
              props: {
                title: "It’s fantastic, happy to hear that!",
                text: "Millions of Sparkle users are transforming their lives with just a few minutes a day—join them and see the difference for yourself."
              }
            }
          }
        ],
      },
      dynamicResponse: true,
      section: 'Leadership'
    },
    {
      name: 'financial_situation',
      component: 'SelectOneRow',
      props: {
        title: "Are you satisfied with your current financial situation?",
        options: [
          {
            text: '❌',
            responsePage: {
              component: 'FeedbackPage',
              props: {
                title: 'Thank you for your openness!',
                text: "Your journey to financial wisdom starts here! Complete the quiz to access top lessons from bestselling books on wealth and business"
              }
            }
          },
          {
            text: '🤔',
            responsePage: {
              component: 'FeedbackPage',
              props: {
                title: "Wondering how to take the first step toward better finances?",
                text: "A remarkable 94% of our users discovered actionable financial insights on Sparkle that significantly improved their financial expertise."
              }
            }
          },
          {
            text: '✅',
            responsePage: {
              component: 'FeedbackPage',
              props: {
                title: "That's amazing! Keep it up 🚀",
                text: "We will shift our focus to other important areas that contribute to your overall growth and progress."
              }
            }
          }
        ],
      },
      dynamicResponse: true,
      section: 'Leadership'
    },
    {
      name: 'start_business',
      component: 'SelectOneList',
      props: {
        options: [
          {
            icon: '🚀',
            text: 'Yes, it’s my ultimate goal!',
            responsePage: {
              component: 'InformationCard',
              props: {
                imgName: 'ceo_start_business_yes',
                title: "Your entrepreneurial spirit is inspiring!",
                text: "Your innovative mindset and strategic thinking are your strengths. With Sparkle, you’ll learn to channel these traits into exceptional outcomes."
              }
            }
          },
          {
            icon: '👀',
            text: 'Perhaps someday down the line.',
            responsePage: {
              component: 'InformationCard',
              props: {
                imgName: 'ceo_start_business_maybe',
                title: "Starting a business can be daunting and filled with uncertainties.",
                text: "But learning from others' experiences can help you find clarity and direction."
              }
            }
          },
          {
            icon: '🙌🏻',
            text: 'No, I’m content with my current path.',
            responsePage: {
              component: 'InformationCard',
              props: {
                imgName: 'ceo_start_business_no',
                title: "Entrepreneurship is a journey with its highs and lows.",
                text: "We're here to provide practical tools and insights to support you along the way."
              }
            }
          }
        ],
        title: "Is starting your own business something you aspire to?"
      },
      dynamicResponse: true,
      section: 'Leadership'
    },
    {
      name: 'company_selection',
      component: 'CompanySelection',
      props: {
        options: [
          { id: 'tesla', name: 'Tesla', imgPath: 'tesla.png' },
          { id: 'shopify', name: 'Shopify', imgPath: 'shopify.png' },
          { id: 'samsung', name: 'Samsung', imgPath: 'samsung.png' },
          { id: 'linkedin', name: 'LinkedIn', imgPath: 'linkedin.png' },
          { id: 'spacex', name: 'SpaceX', imgPath: 'spacex.png' },
          { id: 'adobe', name: 'Adobe', imgPath: 'adobe.png' },
          { id: 'tiktok', name: 'TikTok', imgPath: 'tiktok.png' },
          { id: 'zoom', name: 'Zoom', imgPath: 'zoom.png' },
          { id: 'google', name: 'Google', imgPath: 'google.png' }
        ],
        title: "Which company's success story would you want your own company to resemble?"
      },
      section: 'Interest'
    },
    {
      name: 'social_proof_1',
      component: 'InformationCard',
      props: {
        imgName: 'bookshelf',
        title: '📚 1M+ Sparkle users, with 96% satisfaction, have boosted their learning through book summaries.',
        text: 'Be part of our growing community of passionate learners and find out ways to prioritize self-growth, no matter how busy you are.'
      },
      section: 'Interest'
    },
    {
      name: 'atomic_habits',
      component: 'ImageLike',
      props: {
        options: ['👎', '👍'],
        img: 'example_book_1',
        title: "Do these books catch your interest?"
      },
      section: 'Interest'
    },
    {
      name: 'age_of_amazon',
      component: 'ImageLike',
      props: {
        options: ['👎', '👍'],
        img: 'bezos_book',
        title: "Do these books catch your interest?"
      },
      section: 'Interest'
    },
    {
      name: 'act_like_success',
      component: 'ImageLike',
      props: {
        options: ['👎', '👍'],
        img: 'act_like_success_book',
        title: "Do these books catch your interest?"
      },
      section: 'Interest'
    },
    {
      name: 'lean_startup',
      component: 'ImageLike',
      props: {
        options: ['👎', '👍'],
        img: 'lean_startup_book',
        title: "Do these books catch your interest?"
      },
      section: 'Interest'
    },
    {
      name: 'never_eat_alone',
      component: 'ImageLike',
      props: {
        options: ['👎', '👍'],
        img: 'never_eat_alone_book',
        title: "Do these books catch your interest?"
      },
      section: 'Interest'
    },
    {
      name: 'social_proof_2',
      component: 'SocialProof',
      props: {
        image: 'people_of_world.png',
        heading: '120K+ people are <br /> listening now',
        description: "We know your goals, so let's build your ideal plan together.",
        peopleImage: 'social_proof3_people.png',
        peopleText: 'from users',
        statsText: '',
        isPrimary: true,
        alignCenter: true
      },
      section: 'Interest'
    },
    {
      name: 'self_development_daily',
      component: 'Slider',
      props: {
        options: [
          { label: '5 min', value: 5 },
          { label: '10 min', value: 10 },
          { label: '15 min', value: 15 },
          { label: '20 min', value: 20 },
          { label: '25 min', value: 25 },
          { label: '30 min', value: 30 },
        ],
        title: "Choose your daily self-improvement plan!",
        subtitle: 'Choose how much time you’ll dedicate to self-development each day.'
      }
    },
    {
      name: 'loading_pop_ups',
      component: 'LoadingPopUps',
      props: {
        title: 'Creating your personal experience...',
        popUpHeader: 'To make progress, please clarify',
        imgName: 'open_book',
        quote: {
          text: '"<span class="primary-color">Sparkle</span> is a tool for acquiring and absorbing as much information as possible”',
          author: 'Fig Nelson',
          imgName: 'fig_nelson_person'
        },
        items: [
          { icon: '🎯', title: 'Crafting your vision' },
          { icon: '📈', title: 'Setting Growth Opportunities' },
          { icon: '📚', title: 'Exploring content' },
          { icon: '⚔️', title: 'Customizing challenges' }
        ],
        hasModal: true,
        options: ['No', 'Yes'],
        questions: [
          {
            title: "Do you take time to evaluate your personal growth?",
            qID: 'evaluate_personal_growth'
          },
          {
            title: "Do you push through challenges or let them hold you back?",
            qID: 'push_through_challenges'
          },
          {
            title: "Do you find audio-based learning more effective for you?",
            qID: 'learn_by_listening'
          },
          {
            title: "Do you like revisiting key insights from books you’ve read?",
            qID: 'revisit_insights'
          }
        ]
      }
    },
    {
      name: 'email_form',
      component: 'EmailForm'
    },
    {
      name: 'plan_page',
      component: 'PlanPage'
    },
    {
      name: 'social_proof_3',
      component: 'SocialProof',
      props: {
        image: 'ceo_socialproof3.png',
        heading: 'Elevate your <br /> leadership skills to the <br /> next level in 21 days!',
        description: 'our responses have helped shape a tailored path for your personal development.',
        peopleImage: 'social_proof4_people.png',
        peopleText: '',
        statsText: '1702 people started to grow in the last hour',
        isPrimary: true,
        alignCenter: true
      },
    }
  ]